export default class UnauthenticatedError extends Error {
  constructor(context: string) {
    super()
    this.message = `user must be logged in: ${context}`
  }
}
